export enum LibraryFileScopes {
    shared = 'shared',
    modulePlan = 'module_plan',
}

/** Builds a module scope: module_{name} → maps to {name}:write / {name}:read on the API. */
export function moduleFileScope(moduleName: string): string {
    return `module_${moduleName}`;
}
